import { render, staticRenderFns } from "./kilometer-course-general-info.vue?vue&type=template&id=2e7589a6"
import script from "./kilometer-course-general-info.vue?vue&type=script&lang=js"
export * from "./kilometer-course-general-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports